// fonts
import "@core/styles/fonts";
// external plugins @core pre-configurations
import api from "@core/plugins/api";
import { authTokenInterceptor } from "@core/interceptors/auth-token.interceptor";
import configureInternationalization from "@core/plugins/i18n";
import configureVCalendar from "@core/plugins/v-calendar";
import configureVeeValidate from "@core/plugins/vee-validate";
// @core plugins
import { qLoadingMixin } from "@core/mixins/q-loading.mixin";
import FiltersPlugin from "@core/plugins/filters";
import configureMobile from "@core/plugins/mobile";
import DesignSystemPlugin from "@core/plugins/design-system";
import PosthogPlugin from "@core/plugins/posthog";
import PiniaPlugin from "@core/plugins/pinia";
// @core services
import { EnvironmentManager } from "@core/managers/environment.manager";
import { ExceptionManager } from "@core/managers/exception.manager";
// i18n
import specificLocales from "@extracadabra/i18n/fr-FR/etab.json";
import {
  CapacitorDownloadPluginAdapter,
  DeveloperToolsRepositoryAdapter,
  DocumentManagerRepositoryAdapter,
  CandidateProfileRepositoryAdapter,
  repositoryManager,
} from "@extracadabra/infrastructure";

ExceptionManager.setOnErrorBehavior();

const i18n = configureInternationalization([{ locale: "fr", messages: specificLocales }]);

export default async ({ app }) => {
  const isProduction = EnvironmentManager.isProduction();
  const isDevelopment = EnvironmentManager.isDevelopment();

  if (isProduction) {
    app.config.productionTip = false; // Vue 3 ne supporte pas cette option, donc cette ligne peut être retirée
  }
  if (isDevelopment) {
    app.config.devtools = true;
  }
  app.use(PiniaPlugin);
  app.use(PosthogPlugin, { apiKey: process.env.VUE_APP_POSTHOG_API_KEY, apiHost: process.env.VUE_APP_POSTHOG_API_HOST });
  // Set i18n instance on app
  app.use(i18n);
  // setup api authentication
  api.private.interceptors.request.use(authTokenInterceptor);
  api.comet.interceptors.request.use(authTokenInterceptor);
  configureVeeValidate(app);
  configureVCalendar(app);
  configureMobile(app);
  app.mixin(qLoadingMixin);
  app.use(DesignSystemPlugin);
  app.use(FiltersPlugin);

  const ETAB_REPOSITORY_ADAPTERS = {
    developerTools: DeveloperToolsRepositoryAdapter,
    candidateProfile: CandidateProfileRepositoryAdapter,
  };
  // keep app provide for retro compatibility
  app.provide("repositories", {
    developerToolsRepository: new DeveloperToolsRepositoryAdapter(),
    documentManagerRepository: new DocumentManagerRepositoryAdapter(),
  });

  app.provide("plugins", {
    capacitorDownloadPlugin: new CapacitorDownloadPluginAdapter(),
  });
  repositoryManager.initializeAll(ETAB_REPOSITORY_ADAPTERS);
};
